module.exports = __webpack_public_path__ + "media/src/images/icons/flags/china-8b82a1a4cd0fd3e6b042f6a892b414be.svg";